<template>
  <!-- CUSTOMER INFO -->
  <!-- <hr class="is-large" /> -->
  <div class="section" >
    <p
      class="subtitle is-4 has-text-weight-semibold mb-1"
      ref="stepTwo"
    >{{ $t('ui.customerInfo') }}</p>
    <p>{{ $t('ui.explainWhyAndHowWeUseCustomerInformation') }}</p>

    <!-- customer full name -->
    <div class="mt-1-half field">
      <label
        class="label"
        :class="{ 'has-text-danger': customerFullNameErrMsg}"
      >{{ $t('auth.fullName') }}*</label>
      <p class="control has-icons-right">
        <input
          class="input"
          :class="{  'is-danger': customerFullNameErrMsg }"
          type="text"
          @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
          :placeholder="$t('auth.fullName')"
          v-model="customerFullName"
          @blur="checkCustomerFullName"
        />
        <span class="icon is-right has-text-success" v-if="isCustomerFullNameValid">
          <i class="mdi mdi-check"></i>
        </span>
        <span class="icon is-right has-text-danger" v-if="customerFullNameErrMsg">
          <i class="mdi mdi-alert-circle-outline"></i>
        </span>
      </p>
      <p class="help is-danger" v-if="customerFullNameErrMsg">{{ $t(customerFullNameErrMsg) }}</p>
    </div>

    <!-- customer email -->
    <div class="mt-1 field">
      <label
        class="label"
        :class="{ 'has-text-danger': customerEmailErrMsg}"
      >{{ $t('auth.email') }}*</label>
      <p class="control has-icons-right">
        <input
          class="input"
          :class="{ 'is-danger': customerEmailErrMsg }"
          type="email"
          @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
          :placeholder="$t('auth.enterYourEmail')"
          v-model="customerEmail"
          @blur="checkCustomerEmail"
        />
        <span class="icon is-right has-text-success" v-if="isCustomerEmailValid">
          <i class="mdi mdi-check"></i>
        </span>
        <span class="icon is-right has-text-danger" v-if="customerEmailErrMsg">
          <i class="mdi mdi-alert-circle-outline"></i>
        </span>
      </p>
      <p class="help is-danger" v-if="customerEmailErrMsg">{{ $t(customerEmailErrMsg) }}</p>
    </div>

    <!-- customer phone number -->
    <div class="mt-1 field">
      <label
        class="label"
        :class="{ 'has-text-danger': customerPhoneNumberErrMsg}"
      >{{ $t('auth.phoneNumber') }}</label>
      <p class="control has-icons-right">
        <input
          ref="customerPhoneNumberInput"
          class="input"
          :class="{'is-danger': customerPhoneNumberErrMsg }"
          type="text"
          v-mask="phoneNumberMask"
          :placeholder="phoneNumberPlaceHolder"
          v-model="customerPhoneNumber"
          @focus="$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', false)"
          @blur="checkCustomerPhoneNumber"
          inputmode="numeric"
          pattern="[0-9]*"
        />
        <span class="icon is-right has-text-success" v-if="isCustomerPhoneNumberValid">
          <i class="mdi mdi-check"></i>
        </span>
        <span class="icon is-right has-text-danger" v-if="customerPhoneNumberErrMsg">
          <i class="mdi mdi-alert-circle-outline"></i>
        </span>
      </p>
      <p class="help is-danger" v-if="customerPhoneNumberErrMsg">{{ $t(customerPhoneNumberErrMsg) }}</p>
      <p class="help">{{ $t('ui.phoneNumberOptional') }}</p>
    </div>

    <!-- <p class="is-size-7">{{  }}</p> -->
  </div>
</template>

<script>
import { emailVerifier, phoneNumberVerifier } from "@/mixins/verification";
import { mapGetters } from 'vuex';
export default {
  mixins: [emailVerifier, phoneNumberVerifier],
  data() {
    return {
      // customer full name
      customerFullName: "",
      customerFullNameErrMsg: "",
      isCustomerFullNameValid: false,
      // customer email
      customerEmail: "",
      customerEmailErrMsg: "",
      isCustomerEmailValid: false,
      // customer phone number
      customerPhoneNumber: "",
      customerPhoneNumberErrMsg: "",
      isCustomerPhoneNumberValid: false
    };
  },
  mounted() {
    console.log('customer in fo mounted :', this.userBasket );
    if (this.userBasket) {
      const ci = this.userBasket.customerInfo
      this.customerFullName = ci.fullName
      this.customerEmail = ci.email
      this.phoneNumber = ci.phoneNumber
      console.log('this.fullname :', this.customerFullName);
      console.log('this.customerEmail :', this.customerEmail);
      console.log('this.phoneNumber :', this.phoneNumber);
      if (this.customerFullName.length > 1) this.checkCustomerFullName();
      if (this.customerEmail.length > 1 ) this.checkCustomerEmail();
      if (this.phoneNumber.length > 1) this.checkCustomerPhoneNumber();
    }
  },
  computed:{
    ...mapGetters({
      userBasket: 'user/userBasket'
    })
  },
  watch: {
    // CUSTOMER INFO
    customerFullName(val) {
      this.customerFullNameErrMsg = "";
      this.isCustomerFullNameValid = false;
      // this.isCustomerStepInfoCompleted();
    },
    customerEmail(val) {
      this.customerEmailErrMsg = "";
      this.isCustomerEmailValid = false;
      // if (this.isEmailValid(val)) this.isCustomerEmailValid = true;
      // this.isCustomerStepInfoCompleted();
    },
    customerPhoneNumber(val) {
      this.customerPhoneNumberErrMsg = "";
      this.isCustomerPhoneNumberValid = false;
      // if (this.isPhoneNumberValid(val)) this.isCustomerPhoneNumberValid = true;
      // if (val.length === 0) this.buySteps.stepTwo.hasError = false;
      // this.isCustomerStepInfoCompleted();
      if (val.length === 15) {
        this.$refs.customerPhoneNumberInput.blur()
      }
    }
  },
  methods: {
    // CUSTOMER INFO
    checkCustomerFullName() {
      console.log('checking customer full name',);
      // form is blurred, focused away...
      if (this.customerFullName.length === 0) {
        this.customerFullNameErrMsg = "ui.fieldCantBeEmpty";
        this.isCustomerFullNameValid = false;
        // this.buySteps.stepTwo.hasError = true;
      } else if (this.customerFullName.length < 5) {
        this.customerFullNameErrMsg = "ui.checkInfoOnField";
        this.isCustomerFullNameValid = false;
        // this.buySteps.stepTwo.hasError = true;
      } else {
        // yazmaya basladigi anda erroru kaldiriyoruz zaten
        this.customerFullNameErrMsg = "";
        this.isCustomerFullNameValid = true;
      }
      this.isCustomerStepInfoCompleted();
    },
    checkCustomerEmail() {
      console.log('checking customer email');
      // check if valid email
      const res = this.isEmailValid(this.customerEmail);
      if (res) {
        this.customerEmailErrMsg = "";
        this.isCustomerEmailValid = true;
      } else {
        this.isCustomerEmailValid = false;
        this.customerEmailErrMsg = "auth.invalidEmail";
        // this.buySteps.stepTwo.hasError = true;
      }
      this.isCustomerStepInfoCompleted();
    },
    checkCustomerPhoneNumber() {
      console.log('checking customer phone number');
      if (this.customerPhoneNumber.length === 0) {
        this.isCustomerStepInfoCompleted();
        return
      }

      const res = this.isPhoneNumberValid(this.customerPhoneNumber);
      if (res) {
        this.customerPhoneNumberErrMsg = "";
        this.isCustomerPhoneNumberValid = true;
      } else {
        this.isCustomerPhoneNumberValid = false;
        this.customerPhoneNumberErrMsg = "auth.invalidPhoneNumber";
        // this.buySteps.stepTwo.hasError = true;
      }
      this.isCustomerStepInfoCompleted();
      // console.log('res  phone:', res);
    },
    isCustomerStepInfoCompleted() {
      this.$store.commit('ui/SET_PAYMENT_BOTTOM_NAVBAR', true)
      console.log('checking step info whole');
      let res;
      if (this.customerPhoneNumber.length !== 0) {
        res =
          this.isCustomerEmailValid &&
          this.isCustomerPhoneNumberValid &&
          this.isCustomerFullNameValid;
      } else {
        res = this.isCustomerEmailValid && this.isCustomerFullNameValid;
      }
      if (this.customerFullName.length && this.customerEmail.length) {
        // this.buySteps.stepTwo.hasError = !res;
      }
      if (res) {
        console.log('saving customer info to store');
        this.$store.commit("user/SET_CUSTOMER_INFO", {
          isConfirmed: true,
          fullName: this.customerFullName,
          email: this.customerEmail,
          phoneNumber: this.customerPhoneNumber
        });
      } else {
        this.$store.commit("user/SET_CUSTOMER_INFO", {
          isConfirmed: false,
          fullName: this.customerFullName,
          email: this.customerEmail,
          phoneNumber: this.customerPhoneNumber
        });
      }
      // if (this.customerEmail === )
      // this.buySteps.stepTwo.completed = res;
    }
  }
};
</script>

<style>
</style>